import { render, staticRenderFns } from "./EditWidgetDialog.vue?vue&type=template&id=774689ec&"
import script from "./EditWidgetDialog.vue?vue&type=script&lang=js&"
export * from "./EditWidgetDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports